namespace('compass.hotel');

compass.hotel.VoiceTranscriptionWidget = compass.defineWidget(function VoiceTranscriptionWidget(options) {
	var me = this;
	var settings = options;
	var $j = jQuery;
	var d = $j.dom;

	var isRecording = false;
	var recognition = null;
	var recordingTimeout = null;

	var voiceButton;

	function initSpeechRecognition() {
		// Check for browser support
		if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
			return false;
		}
		
		// Create speech recognition instance
		var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
		recognition = new SpeechRecognition();
		recognition.continuous = false;
		recognition.interimResults = false;
		recognition.lang = 'en-US';

		recognition.onstart = function() {
			isRecording = true;
			$(voiceButton).addClass('recording');
			$(voiceButton).html('<i class="fas fa-stop"></i>');
			me.trigger('VoiceTranscriptionWidget.recordingStarted');
		};
		
		recognition.onresult = function(event) {
			var transcript = '';
			for (var i = event.resultIndex; i < event.results.length; i++) {
				if (event.results[i].isFinal) {
					transcript += event.results[i][0].transcript;
				}
			}
			
			if (transcript) {
				me.trigger('VoiceTranscriptionWidget.transcriptionComplete', transcript);
			}
		};
		
		recognition.onerror = function(event) {
			var errorMessage = 'An error occurred. Please try again.';
			
			// Provide more specific error messages for common issues
			switch (event.error) {
				case 'no-speech':
					errorMessage = 'No speech was detected. Please try again.';
					break;
				case 'audio-capture':
					errorMessage = 'No microphone was found. Please check your microphone settings.';
					break;
				case 'not-allowed':
					errorMessage = 'Microphone access was denied. Please check your browser permissions.';
					break;
				case 'network':
					errorMessage = 'Network error. Please check your internet connection.';
					break;
				case 'aborted':
					// This is usually triggered when the user stops recording, so we don't need to show an error
					return;
			}
			
			me.trigger('VoiceTranscriptionWidget.error', errorMessage);
		};
		
		recognition.onend = function() {
			stopRecording();
		};
		
		return true;
	}

	function startRecording() {
		if (isRecording) return;

		if (!recognition && !initSpeechRecognition()) {
			me.trigger('VoiceTranscriptionWidget.error', 'Your browser does not support speech recognition. Please try typing your search instead.');
			return;
		}
		
		try {
			recognition.start();

			// Auto-stop after 15 seconds
			recordingTimeout = setTimeout(function() {
				if (isRecording) {
					stopRecording();
				}
			}, settings.maxRecordingTime || 15000);
		} catch (error) {
			me.trigger('VoiceTranscriptionWidget.error', 'Could not start speech recognition. Please try again.');
		}
	}

	function stopRecording() {
		if (!isRecording) return;
		
		isRecording = false;
		$(voiceButton).removeClass('recording');
		$(voiceButton).html('<i class="fas fa-microphone"></i>');
		
		if (recordingTimeout) {
			clearTimeout(recordingTimeout);
			recordingTimeout = null;
		}
		
		if (recognition) {
			recognition.stop();
		}
		
		me.trigger('VoiceTranscriptionWidget.recordingStopped');
	}

	me.toggleRecording = function() {
		if (!isRecording) {
			startRecording();
		} else {
			stopRecording();
		}
	};

	me.isRecording = function() {
		return isRecording;
	};

	me.render = function(widgetElem) {
		voiceButton = d.button({
			className: 'voiceTranscriptionButton', 
			title: 'Click to speak your search',
			role: 'button',
			'ARIA-role': 'button',
			'ARIA-label': 'Voice search'
		}, '<i class="fas fa-microphone"></i>');
		
		voiceButton.click(me.toggleRecording);
		
		widgetElem.append(voiceButton);
	};

}, {
	WUID: 'VoiceTranscriptionWidget',
	widgetName: 'VoiceTranscriptionWidget',
	maxRecordingTime: 15000  // 15 seconds
});